import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

export const Modal = ({ onClose, title, children }) => (
  <motion.div 
    initial={{ opacity: 0 }} 
    animate={{ opacity: 1 }} 
    exit={{ opacity: 0 }} 
    className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" 
    onClick={onClose}
  >
    <motion.div 
      initial={{ scale: 0.9 }} 
      animate={{ scale: 1 }} 
      exit={{ scale: 0.9 }} 
      className="bg-[#1a1a1a] rounded-xl p-6 w-96 border border-[#333]" 
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold">{title}</h3>
        <button onClick={onClose} className="p-1 hover:bg-white/10 rounded">
          <X className="w-5 h-5" />
        </button>
      </div>
      {children}
    </motion.div>
  </motion.div>
);

export default Modal;
